import reducer from "./reducer";

export { submitSearch, initSearch, changePage, changePageSize, changeSort } from "./actions";

export {
  getSearchPager,
  getServerPager,
  getSearchTableFilter,
  getSearchFields,
  getSearchTableHeader,
  getSearchTableRows,
  getSearchResultCount,
  getSearchResultsIsFetching,
  getSearchResultsHasError
} from "./selectors";

export default reducer;
